import React from 'react';

const CopyrightWeatherby = () => {
    const date = new Date();

    return (
        <div className="copyright-weatherbys">
            Copyright &copy; {date.getFullYear()} Weatherbys. All rights reserved.
        </div>
    );
};

export default CopyrightWeatherby;



// WEBPACK FOOTER //
// ./src/js/shared/copyright/CopyrightWeatherby.jsx